// @ts-nocheck
class ToastContainer extends HTMLElement {
    constructor() {
        super();
        this.toastDetails = {
            timer: this.getAttribute('data-timer') || 5000,
            success: {
                icon: this.getAttribute("data-success-icon") || null,
                iconUrl: this.getAttribute("data-success-icon-url") || null,
            },
            error: {
                icon: this.getAttribute("data-error-icon") || "fa-circle-xmark",
            },
            warning: {
                icon: this.getAttribute("data-warning-icon") || null,
                iconUrl: this.getAttribute("data-warning-icon-url") || null,
            },
            info: {
                icon: this.getAttribute("data-info-icon") || "fa-circle-info",
            },
            random: {
                icon: this.getAttribute("data-random-icon") || "fa-solid fa-star",
            },
        };
    }

    createToast(id, text, opts = {}) {
        const cfg = this.toastDetails[id] || {};
        return new ToastNotification(
          id,
          text,
          opts.icon    || cfg.icon,
          opts.iconUrl || cfg.iconUrl
        );
      }
    addAndShowToast(id, text, opts = {}) {
        const toast = this.createToast(id, text, opts);
        this.appendChild(toast);
        toast.classList.add("show");
        toast.setAttribute(
          'timeoutId',
          String(setTimeout(() => this.removeAndHideToast(toast), this.toastDetails.timer))
        );
      }

    removeAndHideToast(toast) {
        toast.classList.remove("show");
        toast.classList.add("hide");
        const timeoutId = Number(toast.getAttribute('timeoutId'));
        if (timeoutId) clearTimeout(Number(timeoutId));
        setTimeout(() => toast.remove(), 800);
    }
}

customElements.define('toast-container', ToastContainer);


class ToastNotification extends ToastContainer {
    constructor(id, text, icon, iconUrl) {
        super();
        this.id = id;
        this.text = text;
        this.icon = icon;    // inline SVG string?
        this.iconUrl = iconUrl; // external SVG file?
    }

    renderIcon() {
        // 1) Inline SVG passed directly
        if (this.icon && this.icon.trim().startsWith('<svg')) {
            return this.icon;
        }
        // 2) External SVG URL
        if (this.iconUrl) {
            return `<img src="${this.iconUrl}" alt="${this.id}" class="toast__icon" />`;
        }
        // 3) Fallback to FontAwesome
        return `<i class="fa-solid ${this.icon || 'fa-circle-info'}"></i>`;
    }

    connectedCallback() {
        this.classList.add("toast", this.id);
        this.innerHTML = `
        <div class="column">
          ${this.renderIcon()}
          <span>${this.text}</span>
        </div>
        <toast-remove class="remove_toast">
          <i class="fa-solid fa-xmark"></i>
        </toast-remove>
      `;
    }
}

customElements.define('toast-notification', ToastNotification);

class ToastRemove extends ToastNotification {
    constructor() {
        super();
    }

    connectedCallback() {
        this.bindEvents();
    }

    bindEvents() {
        this.addEventListener('click', () => this.removeToast(this.parentElement));
    }
}

customElements.define('toast-remove', ToastRemove);


class ShowToast {
    constructor(id, text, opts = {}) {
      let container = document.querySelector('toast-container');
      if (!container) {
        container = document.createElement('toast-container');
        document.body.appendChild(container);
      }
      // Pass opts here so addAndShowToast sees it
      container.addAndShowToast(id, text, opts);
    }
  }

// Usage Example:
// This will create a toast container (if not already present), and show a toast notification
// new ShowToast('success', 'Successfully done');
